<section class="software-override-view">
  <div class="software-override-heading">
    <h3>{{ 'software_override.title' | translate }}</h3>
    <p>
      {{
        (forLicenseBatch
          ? 'software_override.license_batch.description'
          : 'software_override.description'
        ) | translate
      }}
    </p>
  </div>

  @if (saveError) {
    <div class="save-error" role="alert">
      <mat-icon>error_outline</mat-icon>
      {{ saveError }}
    </div>
  }

  <mat-stepper #stepper class="override-stepper" [linear]="true">
    <mat-step [completed]="bundleDryRunCompleted">
      <ng-template matStepLabel>
        {{ 'software_override.bundle.title' | translate }}
      </ng-template>

      <app-device-bundle-override-section
        [releaseOptions]="releaseOptions"
        [loading]="releasesLoading"
        [loadError]="releasesLoadError"
        [saving]="saving"
        [supportedProjects]="supportedProjects"
        [unresolvedBundles]="unresolvedBundles"
        (unresolvedBundleRemoved)="removeUnresolvedBundle($event)"
        (releaseToggled)="toggleRelease($event)"
        (bundleSelected)="onBundleSelected($event.option, $event.bundle)"
        (bundlesRequested)="loadBundles($event)"
        (bundlesRetry)="loadBundles($event)"
      ></app-device-bundle-override-section>

      @if (dryRunError) {
        <div class="dry-run-error" role="alert">
          <mat-icon>error_outline</mat-icon>
          {{ dryRunError }}
        </div>
      }

      <div class="step-actions step-actions-end">
        <button
          type="button"
          mat-flat-button
          [disabled]="
            dryRunLoading ||
            saving ||
            releasesLoading ||
            hasIncompleteBundleSelection
          "
          (click)="continueToArtifacts(stepper)"
        >
          {{
            (dryRunLoading
              ? 'software_override.actions.validating_selection'
              : 'software_override.actions.continue_to_artifacts'
            ) | translate
          }}
          @if (!dryRunLoading) {
            <mat-icon>arrow_forward</mat-icon>
          }
        </button>
      </div>
    </mat-step>

    <mat-step [completed]="artifactDryRunCompleted">
      <ng-template matStepLabel>
        {{ 'software_override.artifact.title' | translate }}
      </ng-template>

      <app-device-artifact-override-section
        [components]="softwareComponents"
        [bundleOverrides]="bundleOverridesForReview"
        [softwareSelectionResolutions]="softwareSelectionResolutions"
        [forLicenseBatch]="forLicenseBatch"
        [unresolvedOverrideIds]="unresolvedOverrideIds"
        [saving]="saving"
        (artifactOverrideRequested)="beginArtifactOverride($event)"
        (artifactOverrideCancelled)="cancelArtifactOverride($event)"
        (artifactSelected)="
          onArtifactSelected($event.component, $event.artifact)
        "
        (artifactCleared)="clearArtifactSelection($event)"
        (artifactsRequested)="getProductArtifacts($event)"
      ></app-device-artifact-override-section>

      @if (dryRunError) {
        <div class="dry-run-error" role="alert">
          <mat-icon>error_outline</mat-icon>
          {{ dryRunError }}
        </div>
      }

      <div class="step-actions">
        <button type="button" mat-stroked-button matStepperPrevious>
          <mat-icon>arrow_back</mat-icon>
          {{ 'software_override.actions.back' | translate }}
        </button>
        <button
          type="button"
          mat-flat-button
          [disabled]="dryRunLoading || saving"
          (click)="continueToReview(stepper)"
        >
          {{
            (dryRunLoading
              ? 'software_override.actions.validating_overrides'
              : 'software_override.actions.review_overrides'
            ) | translate
          }}
          @if (!dryRunLoading) {
            <mat-icon>arrow_forward</mat-icon>
          }
        </button>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>
        {{ 'software_override.summary' | translate }}
      </ng-template>

      <app-device-software-override-review
        [components]="softwareComponents"
        [bundleOverrides]="bundleOverridesForReview"
        [releaseOptions]="releaseOptions"
        [supportedProjectIds]="supportedProjectIds"
        [softwareSelectionResolutions]="softwareSelectionResolutions"
        [forLicenseBatch]="forLicenseBatch"
        [unresolvedOverrideIds]="unresolvedOverrideIds"
      ></app-device-software-override-review>

      <div class="step-actions step-actions-start">
        <button type="button" mat-stroked-button matStepperPrevious>
          <mat-icon>arrow_back</mat-icon>
          {{ 'software_override.actions.back' | translate }}
        </button>
      </div>
    </mat-step>
  </mat-stepper>
</section>
